<template>
  <div style="margin: 0;padding: 0;">
    <el-header style="height: 35px;margin: 0;padding: 0;color: #ffffff;">
      刷新时间&nbsp;<el-tag type="danger" effect="dark" v-html="minute">00</el-tag>：<el-tag type="danger" effect="dark" v-html="second">00</el-tag>
      <el-button type="success" size="small" style="float: right;" @click="tp" v-show="isTpShow">投屏<i class="el-icon-copy-document el-icon--right"></i></el-button>
    </el-header>
    <el-container>
      <el-main>
        <el-dialog title="请输入验证码" :visible.sync="dialogFormVisible" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
          <el-form>
            <el-form-item label="手机号码：">
              <el-input v-model="userName" autocomplete="off" class="inputCss" maxlength="11" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="短信验证码：">
              <el-input v-model="yzm"  autocomplete="off" class="inputCss" maxlength="6" show-word-limit></el-input>
              <el-button type="primary" size="small" v-html="messHtml" @click="getMessa" :disabled="isGetMess"></el-button>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="success" @click="tp" v-show="isTpShow">投屏<i class="el-icon-copy-document el-icon--right"></i></el-button>
            <el-button type="primary" @click="checkToken">确 定</el-button>
          </div>
        </el-dialog>
        <div style="width: 100%;">
          <div id="myChart_orderNumber" :style="divHeight">
          </div>
          <div id="myChart_orderPrice" :style="divHeight">
          </div>
          <div id="myChart_ipCount" :style="divHeight">
          </div>
          <div id="myChart_placeNumber" :style="divHeight">
          </div>
        </div>
      </el-main>
      <el-footer>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
  import EchaAverage from '@/assets/echaAverage.js'
  import PurplePassion from '@/assets/purplePassion.js'
  export default {
    data () {
      return {
        divHeight:{
          width: '50%', height: '315px',float:'left'
        },
        minutes:10,
        seconds:0,
        rowList:[],
        orderNumber:[],
        orderPrice:[],
        ipNumber:[],
        placeNumber:[],
        timeInterval:null,
        myChart_orderNumber:null,
        myChart_orderPrice:null,
        myChart_ipCount:null,
        myChart_placeNumber:null,
        dialogFormVisible:true,
        token:"",
        userName:"",
        yzm:"",
        isGetMess:false,
        countdown:60,
        isTpShow:true,
        messHtml:"获取验证码",
        /*builderJson:{
          "all": 10887,
          "charts": {
            "map": 3237,
            "lines": 2164,
            "bar": 7561,
            "line": 7778,
            "pie": 7355,
            "scatter": 2405,
            "candlestick": 1842,
          },
          "components":{},
          "ie": 9743
        },
        downloadJson:{
          "echarts.min.js": 17365,
          "echarts.simple.min.js": 4079,
          "echarts.common.min.js": 6929,
          "echarts.js": 14890
        }*/
      }
    },
    methods:{
      settime(){
        if (this.countdown == 0) {
          this.isGetMess = false;
          this.messHtml="获取验证码";
          this.countdown = 60;
          var _this = this;
          clearTimeout(_this.settime);
        } else {
          this.isGetMess = true;
          this.messHtml="获取验证码("+this.countdown+")";
          this.countdown--;
          var _this = this;
          setTimeout(function() {
            _this.settime()
          },1000)
        }
      },
      getMessa:async function(){
        //发送短信接口
        if(this.userName == ""){
          this.$message({
            message: '请输入手机号码',
            type: 'warning'
          });
        }else if(this.userName.length != 11){
          this.$message({
            message: '输入手机号码有误',
            type: 'warning'
          });
        }else if(isNaN(this.userName)){
          this.$message({
            message: '输入手机号码有误',
            type: 'warning'
          });
        }else{
          await this.$axios.post('/data/formSms',{
            userName:this.userName,
            smsCode:"SMS_177180338",
            t:1
          }).then((response,err) => {
            response = response.data;
            if(response.code == "Login" || response.code == "WhiteList"){
              this.$message.error(response.message);
            }else if(response.code == "Success"){
              this.$message({
                message: response.message,
                type: 'success'
              });
              this.settime();
            }else if(response.data.code == "Fail"){
              this.$message({
                message: response.message,
                type: 'warning'
              });
            }else{
              this.$message({
                message: response.message,
                type: 'warning'
              });
            }
          }).catch(function (error) {
            this.$message.error(error);
          });
        }

      },
      num(n) {
        return n < 10 ? '0' + n : '' + n
      },
      timer () {
        var _this = this
        this.timeInterval = window.setInterval(function () {
          if (_this.seconds === 0 && _this.minutes !== 0) {
            _this.seconds = 59
            _this.minutes -= 1
          } else if (_this.minutes === 0 && _this.seconds === 0) {
            _this.minutes = 10;
            _this.seconds = 0
            _this.isAjax();
            //window.clearInterval(this.timeInterval)
          } else {
            _this.seconds -= 1
          }

        }, 1000)
      },
      isAjax:async function(){
        if(this.token != ""){
          await this.$axios.post('/data/getRealTimeData',{
            token:this.token
          }).then((response,err) => {
            response = response.data;
            if(response.code == "Login" || response.code == "WhiteList"){
              this.$message.error(response.message);
            }else if(response.code == "Success"){
              var tableData = response.data;
              this.rowList = [];
              this.orderNumber = [];
              this.orderPrice = [];
              this.ipNumber = [];
              this.placeNumber = [];
              for(var i=tableData.length-1;i>=0;i--){
                this.orderNumber.push(tableData[i].orderNumber)
                this.orderPrice.push(tableData[i].orderPrice)
                this.ipNumber.push(tableData[i].ipNumber)
                this.placeNumber.push(tableData[i].placeNumber)
                this.rowList.push(tableData[i].dataTime)
              }
              this.myChart_orderNumber.hideLoading();
              this.myChart_orderNumber.setOption(this.drawLine(this.orderNumber,this.rowList,"订单数量",'数量','{value} 张','张'),true);
              this.myChart_orderPrice.hideLoading();
              this.myChart_orderPrice.setOption(this.drawLine(this.orderPrice,this.rowList,"订单金额",'金额','{value} 元','元'),true);
              this.myChart_ipCount.hideLoading();
              this.myChart_ipCount.setOption(this.drawLine(this.ipNumber,this.rowList,"访问量",'数量','{value} 个','个'),true);
              this.myChart_placeNumber.hideLoading();
              this.myChart_placeNumber.setOption(this.drawLine(this.placeNumber,this.rowList,"采购商下单数量",'数量','{value} 位','位'),true);
              this.divHeight.height = (window.innerHeight-58)/2+"px";
            }else if(response.data.code == "Fail"){
              this.$message({
                message: response.message,
                type: 'warning'
              });
            }else{
              this.$message({
                message: response.message,
                type: 'warning'
              });
            }
          }).catch(function (error) {
            this.$message.error(error);
          });
        }else{
          this.$message({
            message: "请输入验证码",
            type: 'warning'
          });
        }
      },
      tp(){
        window.open(location.href+"?t=1","_blank");
      },
      openRealTime(){

      },
      drawLine(data1,data2,name,type,value,dw){
        var ech = new EchaAverage(data1).ReturnNum();
        // 绘制图表
        return {
          title: {
            text: name,
            subtext: '总计: ' + data1[data1.length-1]+' '+dw,
            x: '45%',
            textAlign: 'center'
          },
          tooltip: {
          },
          toolbox: {
            show: true,
            feature: {
              dataZoom: {
                yAxisIndex: 'none'
              },
              dataView: {readOnly: false},
              magicType: {type: ['line', 'bar']},
              restore: {},
              saveAsImage: {}
            }
          },
          grid:{
            top:"50px",
            left:"50px",
            right:"15px",
            bottom:"50px"
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: data2,
            axisPointer: {
              type: 'shadow'
            }
          },
          grid:{
            x: 90, //默认是80px
            y: 60, //默认是60px
            x2: 40, //默认80px
            y2: 45 //默认60px
          },
          yAxis: [
            {
              type: 'value',
              name: type,
              min:ech.min,
              max:ech.max,
              interval:ech.int,
              axisLabel: {
                formatter: value
              }
            }
          ],
          series: [{
            data: data1,
            type: 'line',
            areaStyle: {}
          }]
        }
        /*// 绘制图表
        myChart_orderPrice.setOption({
          title: { text: '订单金额' },
          tooltip: {},
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: _this.rowList
          },
          yAxis: {
            type: 'value'
          },
          series: [{
            data: _this.orderPrice,
            type: 'line',
            areaStyle: {}
          }]
        });
        myChart_ipCount.setOption({
          title: { text: '访问量' },
          tooltip: {},
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: _this.rowList
          },
          yAxis: {
            type: 'value'
          },
          series: [{
            data: _this.ipNumber,
            type: 'line',
            areaStyle: {}
          }]
        });
        myChart_placeNumber.setOption({
          title: { text: '采购商下单数量' },
          tooltip: {},
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: _this.rowList
          },
          yAxis: {
            type: 'value'
          },
          series: [{
            data: _this.placeNumber,
            type: 'line',
            areaStyle: {}
          }]
        });*/
        /*try{
          myChart_order.setOption({
            title: [{
              text: '订单金额',
              subtext: '总金额 ' + _this.builderJson.all+'元',
              x: '25%',
              textAlign: 'center'
            },{
              text: '订单状态',
              subtext: '总计 ' + Object.keys(_this.downloadJson).reduce(function (all, key) {
                return all + _this.downloadJson[key];
              }, 0),
              x: '75%',
              textAlign: 'center'
            }],
            tooltip: {},
            grid: [{
              top: 50,
              width: '50%',
              bottom: '45%',
              left: 10,
              containLabel: true
            }, {
              top: '55%',
              width: '50%',
              bottom: 0,
              left: 10,
              containLabel: true
            }],
            xAxis: [{
              type: 'value',
              max: _this.builderJson.all,
              splitLine: {
                show: false
              }
            }],
            yAxis: [{
              type: 'category',
              data: Object.keys(_this.builderJson.charts),
              axisLabel: {
                interval: 0,
                rotate: 30
              },
              splitLine: {
                show: false
              }
            }],
            series: [{
              type: 'bar',
              stack: 'chart',
              z: 3,
              label: {
                normal: {
                  position: 'right',
                  show: true
                }
              },
              data: Object.keys(_this.builderJson.charts).map(function (key) {
                return _this.builderJson.charts[key];
              })
            }, {
              type: 'pie',
              radius: [0, '30%'],
              center: ['75%', '25%'],
              data: Object.keys(_this.downloadJson).map(function (key) {
                return {
                  name: key.replace('.js', ''),
                  value: _this.downloadJson[key]
                }
              })
            }]
          });
        }catch (e){
          console.log(e);
        }*/
      },
      checkToken:async function(){
        //发送短信接口
        if(this.userName == ""){
          this.$message({
            message: '请输入手机号码',
            type: 'warning'
          });
        }else if(this.userName.length != 11){
          this.$message({
            message: '输入手机号码有误',
            type: 'warning'
          });
        }else if(isNaN(this.userName)){
          this.$message({
            message: '输入手机号码有误',
            type: 'warning'
          });
        }else if(this.yzm == ""){
          this.$message({
            message: '请输入验证码',
            type: 'warning'
          });
        }else if(this.yzm.length != 6){
          this.$message({
            message: '输入验证码有误',
            type: 'warning'
          });
        }else if(isNaN(this.yzm)){
          this.$message({
            message: '输入验证码有误',
            type: 'warning'
          });
        }else{
          await this.$axios.post('/data/checkRealTimeToken',{
            userName:this.userName,
            code:this.yzm,
          }).then((response,err) => {
            response = response.data;
            if(response.code == "Login" || response.code == "WhiteList"){
              this.$message.error(response.message);
            }else if(response.code == "Success"){
              this.dialogFormVisible = false;
              this.token = response.data;
              this.$echarts.registerTheme('purple-passion', PurplePassion)
              this.myChart_orderNumber = this.$echarts.init(document.getElementById('myChart_orderNumber'),'purple-passion')
              this.myChart_orderPrice = this.$echarts.init(document.getElementById('myChart_orderPrice'),'purple-passion')
              this.myChart_ipCount = this.$echarts.init(document.getElementById('myChart_ipCount'),'purple-passion')
              this.myChart_placeNumber = this.$echarts.init(document.getElementById('myChart_placeNumber'),'purple-passion')
              this.isAjax();
              this.timer();
            }else if(response.data.code == "Fail"){
              this.$message({
                message: response.message,
                type: 'warning'
              });
            }else{
              this.$message({
                message: response.message,
                type: 'warning'
              });
            }
          }).catch(function (error) {
            this.$message.error(error);
          });
        }
      },
      GetUrlParms() {
        var args = new Object();
        var query = location.search.substring(1); //获取查询串
        var pairs = query.split("&"); //在逗号处断开
        for (var i = 0; i < pairs.length; i++) {
          var pos = pairs[i].indexOf('='); //查找name=value
          if (pos == -1) continue; //如果没有找到就跳过
          var argname = pairs[i].substring(0, pos); //提取name
          var value = pairs[i].substring(pos + 1); //提取value
          args[argname] = value; //存为属性
        }
        return args;

      }
    },
    mounted(){
      var args=this.GetUrlParms();
      var t = args["t"];
      if(t != null){
        if(t == 1){
          this.isTpShow = false;
        }
      }
    },
    watch: {
      second: {
        handler (newVal) {
          this.num(newVal)

        }
      },
      minute: {
        handler (newVal) {
          this.num(newVal)
        }
      }
    },
    beforeCreate () {

      document.querySelector('body').setAttribute('style', 'background-color:#5B5C6E')

    },
    computed:{
      second:function () {
        return this.num(this.seconds);
      },
      minute:function () {
        return this.num(this.minutes);
      }
    }
  }
</script>
<style scoped>
  .el-main{
    overflow: hidden;
    padding: 0 !important;
    margin: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/dataStatistics/realTimeKanban.vue